import { useState } from 'react';
import { Box, Stack, Tabs, Tab, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../core/theme/theme';
import DesignationCatalogTab from '../features/admin/DesignationCatalogTab';
import TagsCatalogTab from '../features/admin/TagsCatalogTab';
import HourlyRatesTab from '../features/admin/HourlyRatesTab';
import UsersTab from '../features/admin/UsersTab';
import TimeLockTab from '../features/admin/TimeLockTab';

export default function AdminSettings() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<'designations' | 'tags' | 'hourlyRates' | 'roles' | 'timeLock'>('designations');

  return (
    <Box>
      {/* Hero header with background image */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          mx: { xs: -2, sm: -3, md: -5 },
          mt: { xs: -2, sm: -3, md: -5 },
          mb: 3,
          px: { xs: 2, sm: 3, md: 5 },
          py: { xs: 3, sm: 4 },
          minHeight: 140,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <Box
          component="img"
          src="/images/settings-header.webp"
          alt=""
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 30%',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            bgcolor: 'rgba(20, 23, 28, 0.55)',
          }}
        />
        <Stack spacing={0.5} sx={{ position: 'relative', zIndex: 1 }}>
          <Typography variant="h2" sx={{ color: colors.white, fontWeight: 700, fontSize: { xs: '1.75rem', md: '2.5rem' } }}>
            {t('nav.settings')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
            {t('admin.settingsSubtitle')}
          </Typography>
        </Stack>
      </Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab value="designations" label={t('admin.designations.title')} />
        <Tab value="tags" label={t('admin.tags.title')} />
        <Tab value="hourlyRates" label={t('admin.hourlyRates.title')} />
        <Tab value="roles" label={t('admin.roles.title')} />
        <Tab value="timeLock" label={t('kronos.timeLock.adminTitle')} />
      </Tabs>

      {tab === 'designations' && <DesignationCatalogTab />}
      {tab === 'tags' && <TagsCatalogTab />}
      {tab === 'hourlyRates' && <HourlyRatesTab />}
      {tab === 'roles' && <UsersTab />}
      {tab === 'timeLock' && <TimeLockTab />}
    </Box>
  );
}
